var _metadata, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOxygenRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "oxygenregular",
    horizAdvX: 1626
  }, /*#__PURE__*/React.createElement("fontFace", {
    unitsPerEm: 2048,
    ascent: 1638,
    descent: -410
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 511
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uFB01",
    horizAdvX: 1088,
    d: "M20 980v118h161v40q3 121 21.5 196.5t62.5 121.5t108 63t166 17h73l20 -128h-94q-37 0 -64.5 -5t-48 -13t-34 -25t-22 -35.5t-13 -50.5t-6 -63t-1.5 -80v-38h607v-1098h-168v980h-439v-980h-168v980h-161zM788 1298v198h168v-198h-168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uFB02",
    horizAdvX: 1237,
    d: "M20 980v118h161v30q3 111 28.5 186.5t74.5 118.5t112.5 61t153.5 18q40 0 426 -22v-1040q0 -199 24 -260.5t134 -61.5q21 0 73 4l11 -131q-115 -13 -124 -13q-41 0 -74 3.5t-60 13.5t-47.5 21.5t-36.5 33t-27 41.5t-18.5 53.5t-12 63.5t-7 77.5t-3 88.5t-0.5 103v889 q-59 4 -105.5 6t-72 2.5t-41 0t-23.5 -1t-9 -0.5q-112 0 -157.5 -54t-49.5 -194q0 -6 -0.5 -18t-0.5 -19h249v-118h-249v-980h-168v980h-161z"
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    horizAdvX: 682
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    horizAdvX: 511
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\t",
    horizAdvX: 511
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA0",
    horizAdvX: 511
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    horizAdvX: 586,
    d: "M160 120q0 53 35.5 92.5t97.5 39.5q63 0 98 -39t35 -93t-35 -93t-98 -39q-62 0 -97.5 39.5t-35.5 92.5zM194 1354v142h197v-142l-56 -919h-79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    horizAdvX: 710,
    d: "M139 1510h151l-29 -494h-101zM425 1510h151l-29 -494h-101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    horizAdvX: 1134,
    d: "M91 410l10 126h183l61 394h-177l9 125h193l83 407h153l-79 -407h234l71 407h128l-66 -407h138l-14 -124h-147l-67 -395h147l-10 -126h-155l-86 -433h-151l84 433h-235l-80 -433h-129l73 433h-171zM422 536h236l79 395h-235z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    horizAdvX: 1241,
    d: "M94 100l52 144q202 -99 434 -112v580l-147 37q-337 85 -337 360q0 197 128 299.5t356 114.5v170h95v-168q255 -8 414 -107l-50 -141q-61 34 -160.5 61.5t-203.5 32.5v-508l104 -25q180 -43 273 -137.5t93 -268.5q0 -215 -125.5 -329t-344.5 -125v-173h-95v173 q-160 5 -285.5 40.5t-200.5 81.5zM276 1121q0 -85 55.5 -136.5t166.5 -78.5l82 -20v484q-304 -18 -304 -249zM675 131q291 15 291 295q0 96 -51.5 155.5t-187.5 93.5l-52 13v-557z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    horizAdvX: 1877,
    d: "M103 1104q0 167 86.5 276t230.5 109q145 0 232.5 -108.5t87.5 -276.5q0 -164 -88 -270t-232 -106q-145 0 -231 105.5t-86 270.5zM230 1104q0 -115 49.5 -187.5t140.5 -72.5t141 74.5t50 185.5q0 115 -51 194.5t-140 79.5q-90 0 -140 -80t-50 -194zM401 -4l795 1466h162 l-822 -1466h-135zM1079 369q0 169 93 277t259 108q169 0 261 -106.5t92 -278.5q0 -168 -93.5 -276t-259.5 -108q-168 0 -260 107.5t-92 276.5zM1205 369q0 -115 59.5 -193t166.5 -78t166.5 79t59.5 192q0 115 -59.5 193t-166.5 78t-166.5 -79t-59.5 -192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    horizAdvX: 1477,
    d: "M104 395q0 153 86.5 257t250.5 187q-93 101 -133 169t-40 157q0 149 105.5 236.5t283.5 87.5q105 0 191.5 -32.5t142 -104t55.5 -170.5q0 -64 -25.5 -120.5t-74 -102.5t-106 -83t-133.5 -72l401 -429q80 84 142 224l121 -92q-62 -136 -159 -250l181 -216 q-74 -28 -157 -52l-136 154q-206 -166 -480 -166q-253 0 -384.5 110.5t-131.5 307.5zM281 406q0 -129 92 -201.5t256 -72.5q196 0 356 127q-74 80 -220.5 234t-220.5 233q-126 -64 -194.5 -140t-68.5 -180zM455 1165q0 -68 36.5 -124.5t113.5 -130.5q61 30 98.5 52 t77.5 54.5t58.5 70.5t18.5 84q0 83 -57 128.5t-141 45.5q-93 0 -149 -47.5t-56 -132.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    horizAdvX: 423,
    d: "M127 1486h156l-20 -511h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    horizAdvX: 609,
    d: "M103 598q0 490 273 888h155q-258 -402 -258 -884q0 -226 68 -456t190 -417h-153q-129 179 -202 403.5t-73 465.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    horizAdvX: 609,
    d: "M77 1486h155q274 -404 274 -888q0 -241 -73 -465t-203 -404h-152q122 187 190 417t68 456q0 480 -259 884z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    horizAdvX: 1105,
    d: "M87 1091l50 171l357 -151l-37 411h186l-36 -411l359 151l50 -171l-367 -83q11 -15 107.5 -142t144.5 -191q-26 -16 -77 -47t-77 -47l-200 362l-189 -362l-156 94l248 333z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    horizAdvX: 1126,
    d: "M102 582v136h398v424h137v-424h390v-136h-391v-429h-137v429h-397z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    horizAdvX: 505,
    d: "M109 -278q3 29 17.5 153.5t22.5 209.5t12 149h197v-44q-49 -198 -144 -468h-105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    horizAdvX: 672,
    d: "M86 497v147h500v-147h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    horizAdvX: 494,
    d: "M128 120q0 54 35 93t98 39t98 -39t35 -93t-35 -93t-98 -39q-62 0 -97.5 39.5t-35.5 92.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    horizAdvX: 952,
    d: "M50 -218l676 1684h146l-678 -1684h-144z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    horizAdvX: 1241,
    d: "M109 751q0 139 19.5 257t60.5 214t101.5 163t144.5 103.5t187 36.5q128 0 226.5 -56t160 -159.5t92.5 -244t31 -314.5q0 -169 -29 -307t-89 -244t-159.5 -164.5t-232.5 -58.5t-233 58.5t-160.5 164.5t-90 244t-29.5 307zM301 757q0 -183 36.5 -323.5t109.5 -222.5 t175 -82t175 82t109.5 222.5t36.5 323.5q0 180 -36.5 317.5t-109.5 218t-175 80.5t-175 -80.5t-109.5 -218t-36.5 -317.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    horizAdvX: 626,
    d: "M37 1198v167q16 7 65 28t73.5 32t61.5 31t65 40h159v-1496h-177v1311q-101 -66 -247 -113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    horizAdvX: 1116,
    d: "M90 164l517 574q52 58 100.5 150t70.5 156l23 63q0 124 -69 192.5t-196 68.5q-212 0 -334 -123l-58 150q138 130 404 130q204 0 325 -110.5t121 -295.5q-4 -14 -12 -37.5t-34.5 -91.5t-55.5 -129t-73.5 -134t-90.5 -122l-422 -451h693l-11 -154h-875z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    horizAdvX: 1103,
    d: "M105 93l56 147q141 -111 336 -111q150 0 238.5 74.5t88.5 208.5q0 73 -22.5 127.5t-60 88t-96 54t-120 29t-142.5 10.5q-10 0 -30 0.5t-30 0.5v149h50q70 1 123.5 7.5t107 23.5t88.5 45t57 75t22 111q0 240 -275 240q-99 0 -186 -29t-149 -78l-56 146q149 113 429 113 q113 0 209 -41.5t158 -127t62 -200.5q0 -140 -69 -230t-194 -129q140 -30 219.5 -131t79.5 -256q0 -197 -141 -315t-362 -118q-134 0 -238.5 35t-152.5 81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    horizAdvX: 1211,
    d: "M108 371v153l657 972h187v-980h184l-14 -145h-170v-371h-168v371h-676zM284 516h500v753z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    horizAdvX: 1177,
    d: "M121 114l65 141q148 -116 343 -116q164 0 259 93t95 243q0 134 -80 217.5t-228 83.5t-238 -99l-139 19l39 800h767l-14 -164h-611q-10 -291 -15 -471q113 72 245 72q111 0 198.5 -35.5t143 -97.5t84.5 -144.5t29 -178.5q0 -227 -145.5 -363.5t-395.5 -136.5 q-251 0 -402 137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    horizAdvX: 1199,
    d: "M103 472q0 163 59.5 291.5t215.5 325.5q38 48 120 148t146 176l63 76h231l-526 -628q113 60 225 60q126 0 233 -59.5t172 -169t65 -243.5q0 -204 -137.5 -338t-362.5 -134q-117 0 -213.5 39.5t-159 107t-97 157t-34.5 191.5zM292 453q0 -89 33.5 -161t105 -117.5 t170.5 -45.5q148 0 232.5 91t84.5 226q0 142 -84.5 233.5t-232.5 91.5q-157 0 -233 -89t-76 -229z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    horizAdvX: 1052,
    d: "M100 1341l11 155h867v-136l-535 -1360h-182l514 1341h-675z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    horizAdvX: 1182,
    d: "M103 385q0 143 82 249t229 154q-280 99 -280 360q0 177 128 277t332 100q203 0 329 -100t126 -277q0 -132 -68 -222t-190 -138q135 -48 212 -154t77 -249q0 -192 -138.5 -300t-347.5 -108q-136 0 -245.5 45.5t-177.5 139.5t-68 223zM279 397q0 -123 89 -195.5t226 -72.5 t223.5 72.5t86.5 195.5q0 119 -84 196.5t-226 109.5q-143 -33 -229 -110.5t-86 -195.5zM311 1152q0 -236 283 -299q279 63 279 299q0 103 -81 162t-198 59q-118 0 -200.5 -59t-82.5 -162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    horizAdvX: 1165,
    d: "M86 1053q0 204 140 338t366 134q117 0 212.5 -37.5t157 -103t95 -153t33.5 -189.5q0 -143 -49 -259t-169 -279q-43 -57 -143.5 -183t-179.5 -223l-79 -98h-220l531 658q-113 -60 -225 -60q-127 0 -233.5 55.5t-171.5 160.5t-65 239zM275 1056q0 -140 84 -224t233 -84 q158 0 233.5 87t75.5 226q0 137 -77.5 224.5t-225.5 87.5q-149 0 -236 -91.5t-87 -225.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    horizAdvX: 494,
    d: "M146 -25v233h206v-233h-206zM146 893v231h206v-231h-206z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    horizAdvX: 518,
    d: "M138 -310l56 507h182l-125 -507h-113zM174 893v231h206v-231h-206z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    horizAdvX: 1175,
    d: "M103 605v97l960 493v-158l-775 -379l773 -354v-158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    horizAdvX: 1228,
    d: "M131 799v144h966v-144h-966zM132 377v142h965v-142h-965z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    horizAdvX: 1176,
    d: "M115 152v159l774 347l-772 386v156l958 -499v-97z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    horizAdvX: 865,
    d: "M73 1427q123 97 331 97q162 0 261.5 -85.5t99.5 -238.5q0 -77 -22.5 -150t-62.5 -142.5t-83.5 -135t-98 -157.5t-94.5 -180h-87q0 64 29.5 147t71.5 162.5t83.5 157.5t71 154t29.5 130q-1 95 -61 141t-164 46q-129 0 -259 -81zM242 120q0 53 35.5 92.5t97.5 39.5 q63 0 98 -39t35 -93t-35 -93t-98 -39q-62 0 -97.5 39.5t-35.5 92.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    horizAdvX: 1814,
    d: "M111 645q0 178 62.5 335t172 269.5t266.5 177.5t339 65q214 0 384 -86t269 -248t99 -374q0 -117 -35.5 -218t-94 -167t-132.5 -103t-151 -37q-81 0 -135 45t-65 126q-45 -64 -113 -113t-155 -49q-130 0 -207 93.5t-77 254.5q0 207 111.5 345t306.5 138q143 0 304 -55 q-7 -50 -21.5 -144.5t-22 -148.5t-14.5 -120t-7 -108q0 -142 111 -142q101 0 183.5 120.5t82.5 289.5q0 265 -175.5 421t-454.5 156q-201 0 -360.5 -93t-248 -257t-88.5 -369q0 -306 174.5 -480t466.5 -174q249 0 446 113l35 -111q-190 -128 -482 -128q-350 0 -562 209 t-212 567zM680 609q0 -99 40.5 -156t120.5 -57q106 0 161 87.5t75 246.5q9 71 26 228q-57 20 -146 20q-92 0 -155.5 -51t-92.5 -132.5t-29 -185.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    horizAdvX: 1302,
    d: "M3 0l568 1482h177l551 -1482h-178l-173 469h-590l-179 -469h-176zM416 614h476q-211 613 -233 689z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    horizAdvX: 1286,
    d: "M174 0v1479h424q285 0 422.5 -87t137.5 -277q0 -28 -3.5 -55.5t-18 -70.5t-39.5 -78.5t-73.5 -71t-113.5 -56.5q149 -28 226 -126t77 -236q0 -201 -131.5 -311t-391.5 -110h-516zM347 142h309q188 0 282 69.5t94 216.5q0 153 -101.5 214.5t-316.5 61.5h-267v-562z M347 843h317q155 0 234 54t79 192q0 139 -94.5 191.5t-293.5 52.5h-242v-490z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    horizAdvX: 1290,
    d: "M112 745q0 166 49 306t138.5 240.5t223.5 156.5t298 56q249 0 420 -110l-68 -141q-164 99 -350 99q-167 0 -287.5 -81t-179.5 -218t-59 -315q0 -133 32 -242.5t96 -192t166.5 -128t235.5 -45.5q171 0 354 89l29 -147q-149 -94 -403 -94q-167 0 -299.5 55.5t-219 157 t-131.5 242t-45 312.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    horizAdvX: 1502,
    d: "M174 0v1479h410q185 0 331 -43.5t253.5 -132t164.5 -231t57 -331.5q0 -361 -205 -551t-572 -190h-439zM347 151h261q292 0 444.5 147.5t152.5 437.5q0 310 -160 451t-466 141h-232v-1177z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    horizAdvX: 1143,
    d: "M174 0v1479h848l-7 -153h-668v-484h635v-151h-635v-538h690l-8 -153h-855z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    horizAdvX: 1041,
    d: "M174 0v1479h821l-7 -153h-641v-519h611v-147h-611v-660h-173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    horizAdvX: 1461,
    d: "M113 738q0 224 85 396t253 271t398 99q255 0 448 -116l-66 -143q-186 107 -380 107q-135 0 -241.5 -46.5t-174 -129t-103 -194t-35.5 -244.5q0 -282 140.5 -445.5t414.5 -163.5q156 0 317 63v422h-349l6 151h505v-676q-126 -60 -243.5 -85.5t-268.5 -25.5 q-169 0 -303.5 56.5t-222 158t-134 240.5t-46.5 305z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    horizAdvX: 1488,
    d: "M174 0v1479h173v-635h794v635h173v-1479h-173v692h-794v-692h-173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    horizAdvX: 540,
    d: "M182 0v1479h173v-1479h-173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    horizAdvX: 550,
    d: "M-40 -72h74q53 0 89.5 13t56.5 32.5t30.5 55.5t13 67.5t2.5 84.5v1315h177v-1255q0 -73 -3 -123t-12 -101.5t-26.5 -84.5t-45.5 -63.5t-69.5 -47t-98.5 -26t-132 -9.5h-35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    horizAdvX: 1242,
    d: "M173 0v1479h174v-726l650 726h217l-600 -666l646 -813h-212l-566 706l-135 -119v-587h-174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    horizAdvX: 1021,
    d: "M174 0v1479h174v-1325h651l-6 -154h-819z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    horizAdvX: 1817,
    d: "M175 0v1479h224l515 -1178l510 1178h218v-1479h-168v890l7 354l-37 -101l-453 -1052h-169l-454 1056l-38 101l7 -362v-886h-162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    horizAdvX: 1516,
    d: "M174 0v1479h193l770 -1164l51 -69q-7 319 -7 369v864h161v-1479h-196l-768 1164l-50 69q8 -210 8 -375v-858h-162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    d: "M112 740q0 355 185 560t518 205q328 0 513.5 -206.5t185.5 -559.5q0 -169 -46.5 -309t-134 -240.5t-220.5 -156t-299 -55.5q-224 0 -383.5 95.5t-239 266t-79.5 400.5zM296 739q0 -285 131 -447.5t387 -162.5t385.5 162t129.5 448q0 292 -130.5 453t-383.5 161t-386 -161 t-133 -453z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    horizAdvX: 1159,
    d: "M146 0v1496h482q110 0 199 -23t158 -70t107 -126t38 -184q0 -87 -16 -155.5t-55 -128.5t-102 -99.5t-161.5 -62t-228.5 -22.5q-103 0 -244 13v-638h-177zM323 780q193 -2 261 -2q98 0 168 19t107.5 47t59 73t26.5 82.5t5 90.5q0 127 -85.5 187t-232.5 60h-309v-557z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    d: "M112 740q0 355 185 560t518 205q328 0 513.5 -206.5t185.5 -559.5q0 -257 -105 -442.5t-301 -265.5q16 -28 44 -73.5t101.5 -148t131.5 -159.5l-118 -120q-48 48 -159 195.5t-166 261.5q-62 -9 -128 -9q-224 0 -383.5 95.5t-239 266t-79.5 400.5zM296 739 q0 -285 131 -447.5t387 -162.5t385.5 162t129.5 448q0 292 -130.5 453t-383.5 161t-386 -161t-133 -453z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    horizAdvX: 1339,
    d: "M147 0v1496h473q82 0 145 -4t125.5 -14.5t108.5 -29t86 -48t64.5 -70.5t38.5 -97.5t14 -127.5q0 -140 -73.5 -241t-208.5 -140q0 -2 20 -36t47.5 -83.5t42.5 -82.5l242 -522h-200l-204 464q-83 187 -106 225q-73 -5 -173 -5l-265 8v-692h-177zM324 841q41 0 169.5 -2 t198.5 -2q191 0 266 63.5t75 201.5q0 121 -72 180t-241 59h-396v-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    horizAdvX: 1227,
    d: "M94 100l52 144q231 -114 495 -114q325 0 325 296q0 96 -51.5 155.5t-187.5 93.5l-294 74q-337 85 -337 360q0 211 145 313.5t401 102.5q134 0 251 -29t196 -78l-50 -141q-67 37 -177.5 66t-223.5 29q-362 0 -362 -251q0 -85 55.5 -136.5t166.5 -78.5l281 -68 q180 -43 273 -137.5t93 -268.5q0 -226 -138.5 -340.5t-376.5 -114.5q-178 0 -316.5 36.5t-219.5 86.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    horizAdvX: 1099,
    d: "M7 1326v153h1084v-153h-455v-1326h-174v1326h-455z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    horizAdvX: 1438,
    d: "M156 521v958h174v-961q0 -201 95 -296t294 -95q194 0 289.5 96t95.5 296v960h173v-960q0 -255 -139.5 -398t-424.5 -143t-421 143t-136 400z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    horizAdvX: 1242,
    d: "M-5 1479h185l329 -938q64 -183 111 -345q15 75 112 348q156 447 330 935h185l-537 -1479h-180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    horizAdvX: 2013,
    d: "M0 1479h181l366 -1273l366 1246h195l355 -1247l369 1274h181l-452 -1479h-189l-360 1243l-378 -1243h-188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    horizAdvX: 1240,
    d: "M9 0l506 772l-473 707h201l383 -592l398 592h185l-476 -704l498 -775h-199l-412 661l-423 -661h-188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    horizAdvX: 1194,
    d: "M-1 1479h187l405 -725l416 725h188l-522 -889v-590h-175v586z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    horizAdvX: 1184,
    d: "M86 0v136l804 1189h-775v154h996v-129l-809 -1196h816l-6 -154h-1026z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    horizAdvX: 676,
    d: "M143 -293v1776h453v-132h-280v-1512h280v-132h-453z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    horizAdvX: 843,
    d: "M52 1464h156l599 -1524h-156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    horizAdvX: 676,
    d: "M80 -161h280v1512h-280v132h453v-1776h-453v132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    horizAdvX: 1157,
    d: "M69 589l445 927h102l470 -927h-143l-378 746l-351 -746h-145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    horizAdvX: 1085,
    d: "M73 -170h939v-134h-939v134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    horizAdvX: 643,
    d: "M85 1638h250l185 -387h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    horizAdvX: 1098,
    d: "M94 289q0 168 127.5 249t367.5 101q33 3 99.5 8.5t99.5 8.5v97q0 116 -54 172t-170 56q-162 0 -327 -80q-5 12 -26 69.5t-22 59.5q73 41 173.5 65.5t204.5 24.5q205 0 295.5 -89.5t90.5 -304.5v-726h-130q-15 64 -29 138q-91 -91 -171 -126t-188 -35q-154 0 -247.5 80.5 t-93.5 231.5zM265 290q0 -88 52 -133t143 -45q119 0 209.5 65.5t116.5 176.5v185q-5 0 -60.5 -5t-72.5 -6q-217 -19 -302.5 -71t-85.5 -167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    horizAdvX: 1215,
    d: "M148 0v1523l167 10v-363q0 -134 -4 -230q58 83 150.5 131.5t197.5 48.5q146 0 252 -74t159 -201t53 -291q0 -170 -52.5 -299t-159 -203.5t-254.5 -74.5q-109 0 -199 47t-150 128l-17 -152h-143zM314 550q0 -434 327 -434q81 0 142.5 33.5t97 94t53 136.5t17.5 169 q0 126 -29.5 220t-100.5 153t-179 59q-159 0 -243.5 -109.5t-84.5 -321.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    horizAdvX: 968,
    d: "M92 545q1 256 139.5 415.5t379.5 159.5q85 0 164.5 -21t125.5 -55l-46 -130q-117 63 -247 63q-159 0 -251.5 -116t-92.5 -317q0 -196 91.5 -310.5t253.5 -114.5q129 0 264 70l21 -133q-109 -79 -287 -79q-242 0 -378.5 157t-136.5 411z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    horizAdvX: 1211,
    d: "M92 553q0 254 125 410.5t335 156.5q109 0 205.5 -47.5t144.5 -127.5l-3 95v483l165 10v-1533h-142l-22 159q-54 -83 -144 -132t-201 -49q-217 0 -340 154.5t-123 420.5zM265 549q0 -128 31.5 -222t101.5 -150t173 -56q165 0 245.5 106t80.5 303q0 222 -77.5 334.5 t-250.5 112.5q-77 0 -136 -33t-95 -92t-54.5 -135.5t-18.5 -167.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    horizAdvX: 1108,
    d: "M93 545q0 255 133 413.5t350 161.5q204 0 323.5 -139.5t119.5 -372.5q0 -12 -0.5 -44t-0.5 -46h-753q3 -187 96.5 -291.5t251.5 -104.5q174 0 349 92l26 -135q-167 -102 -381 -102q-239 0 -376.5 152t-137.5 416zM270 644h579q0 163 -73.5 250.5t-201.5 87.5t-209 -90.5 t-95 -247.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    horizAdvX: 669,
    d: "M34 973l14 110l164 14v49q2 212 79.5 307.5t250.5 95.5q67 0 164 -15l-11 -131q-89 13 -135 13q-104 0 -142.5 -60t-38.5 -208v-51h264v-124h-264v-973h-167v973h-178z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    horizAdvX: 1187,
    d: "M70 545q0 120 29.5 222t87.5 182t152.5 125.5t216.5 45.5q108 0 188.5 -41.5t144.5 -127.5v146h163v-1018q0 -70 -3.5 -122.5t-17 -116.5t-36.5 -110t-64.5 -92.5t-99 -75t-142.5 -46.5t-192 -18h-185l-15 151h204q85 0 148 12t105 39.5t68 61t39.5 87t18 106t4.5 128.5 v97q-60 -86 -139 -132.5t-201 -46.5q-94 0 -173.5 32.5t-134 86.5t-93 125t-56 147t-17.5 153zM242 554q0 -58 12 -115t38 -111t63 -94.5t92.5 -65.5t121.5 -25q85 0 149 30t100 83t53.5 118t17.5 142v81q0 80 -18 147.5t-55.5 121t-100 83.5t-145.5 30q-69 0 -125.5 -26 t-93 -68.5t-62 -99t-36.5 -114.5t-11 -117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    horizAdvX: 1112,
    d: "M145 0v1523l167 10v-446q0 -57 -4 -141q141 174 374 174q367 0 367 -431v-689h-167v663q0 165 -52.5 240t-183.5 75q-126 0 -212.5 -63t-112.5 -163q-9 -75 -9 -167v-585h-167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    horizAdvX: 511,
    d: "M172 0v1097h168v-1097h-168zM172 1298v198h168v-198h-168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    horizAdvX: 445,
    d: "M-77 -351h52q39 0 67.5 4.5t49 11.5t33.5 23t20.5 30.5t11 43.5t4.5 52t1 65v1218h168v-1236q0 -106 -13.5 -171t-51 -110.5t-101.5 -63.5t-167 -18h-52zM162 1298v198h168v-198h-168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    horizAdvX: 1041,
    d: "M145 0v1523l166 10v-797v-140q6 6 18 20t19 21q87 95 450 460h212l-456 -462l488 -635h-208l-401 540l-122 -105v-435h-166z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    horizAdvX: 569,
    d: "M145 365v1158l166 10v-1102q0 -68 1.5 -109t7.5 -80.5t16 -59.5t29 -36.5t45.5 -22t65.5 -5.5q32 0 126 12l9 -133q-103 -17 -173 -17q-160 0 -226.5 86t-66.5 299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    horizAdvX: 1773,
    d: "M143 1097h140l21 -157q50 76 142 128t209 52q61 0 112.5 -12.5t86 -31.5t61.5 -45.5t42 -52t25 -53.5q120 195 367 195q183 0 268.5 -104.5t85.5 -309.5v-706h-167v571q0 80 -3.5 134t-16 110t-35 88.5t-62.5 53t-96 20.5q-110 0 -187.5 -59t-110.5 -166q-9 -72 -9 -154 v-598h-167v589q0 74 -5 128.5t-19 106t-37.5 83.5t-62.5 51t-93 19q-120 0 -201.5 -61t-109.5 -162q-9 -77 -9 -167v-587h-167q-2 1029 -2 1097z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    horizAdvX: 1184,
    d: "M143 0v1097h140l21 -157q65 81 162.5 130.5t210.5 49.5q190 0 281 -106.5t91 -327.5v-686h-167q0 660 -1 707q-4 140 -56.5 205t-175.5 65q-129 0 -215 -62t-112 -161q-10 -67 -10 -154v-600h-169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    horizAdvX: 1201,
    d: "M92 548q0 256 137 414t376 158q235 0 369 -158.5t134 -412.5q0 -255 -136 -413.5t-376 -158.5q-231 0 -367.5 160t-136.5 411zM265 546q0 -195 86.5 -312.5t252.5 -117.5q164 0 247.5 117t83.5 315q0 201 -82.5 316.5t-251.5 115.5q-164 0 -250 -118t-86 -316z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    horizAdvX: 1201,
    d: "M143 -476v1573h147l16 -149q144 172 346 172q150 0 254 -75t153.5 -203t49.5 -299q0 -164 -54 -291.5t-158.5 -201t-244.5 -73.5q-106 0 -199 47.5t-149 125.5q6 -108 6 -210v-405zM309 567q0 -223 74.5 -336t245.5 -113q76 0 136 34.5t97 94.5t56 136.5t19 165.5 q0 188 -79 308.5t-231 120.5q-318 0 -318 -411z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    horizAdvX: 1211,
    d: "M96 541q0 170 52 299.5t158 204.5t254 75q205 0 345 -178l12 155h148v-1563l-167 -10v487q0 73 5 148q-56 -84 -147 -133t-204 -49q-143 0 -247.5 74t-156.5 200t-52 290zM268 547q0 -93 17.5 -168.5t53.5 -134t95.5 -91t139.5 -32.5q166 0 244.5 104t80.5 304 q0 221 -77 334t-249 113q-104 0 -174.5 -59.5t-100.5 -153t-30 -216.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 746,
    d: "M148 1097h139l16 -197q57 93 145 150t187 57q45 0 82 -6l-6 -154q-46 8 -80 8q-140 0 -227.5 -97.5t-87.5 -241.5v-616h-167q-1 1010 -1 1097z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    horizAdvX: 953,
    d: "M103 821q0 129 103.5 214t283.5 85q186 0 339 -72l-49 -128q-155 64 -290 64q-105 0 -164.5 -41.5t-59.5 -116.5q0 -64 43 -98t172 -78q33 -12 83 -28q166 -54 235 -127.5t69 -198.5q-2 -152 -109 -235.5t-289 -83.5q-112 0 -206.5 24t-153.5 62l21 141q167 -89 328 -89 q244 0 251 172q0 73 -52 115t-204 94l-83 29q-144 48 -205.5 119t-62.5 177z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    horizAdvX: 710,
    d: "M28 973l7 110l155 14l57 251l110 4v-255h305v-124h-305v-629q0 -125 38 -176t130 -51q33 0 143 16l7 -132q-119 -21 -182 -21q-162 0 -230 79t-72 255v659h-163z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    horizAdvX: 1100,
    d: "M105 366v731h168v-733q0 -72 20.5 -122t59 -77.5t87 -39.5t111.5 -12q130 0 202.5 57t72.5 194v733h168v-731q0 -84 -24 -151t-64.5 -111.5t-97.5 -73.5t-120.5 -42t-136.5 -13q-72 0 -136 13t-121.5 42.5t-99 74t-65.5 111.5t-24 150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    horizAdvX: 1031,
    d: "M-1 1097h179l242 -652l100 -278q34 107 94 276q76 213 236 654h178l-422 -1097h-182z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    horizAdvX: 1606,
    d: "M19 1097h173l235 -898q49 160 288 898h189q238 -754 280 -895l232 895h171l-316 -1097h-181q-231 738 -286 919q-31 -110 -71 -238t-70 -220t-78 -238t-73 -223h-180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    horizAdvX: 1057,
    d: "M31 0l402 558l-387 539h191l293 -418l294 418h191l-388 -541l398 -556h-185l-309 441l-309 -441h-191z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    horizAdvX: 1022,
    d: "M3 1097h177l346 -913l308 913h177q-444 -1222 -459 -1260q-69 -173 -167 -253.5t-258 -80.5q-48 0 -101 8l-10 142q56 -4 84 -4q113 0 171.5 41.5t104.5 155.5q41 105 61 162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    horizAdvX: 912,
    d: "M83 0v126l561 839h-546v132h733v-132l-560 -833h578v-132h-766z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    horizAdvX: 733,
    d: "M75 556v145q32 0 57.5 3t46 10.5t36 14.5t27 21t19.5 25t13.5 32t8.5 36.5t4 43t1.5 47t0.5 53.5v243q0 155 89.5 232t262.5 77v-138q-109 -1 -148 -51t-39 -177v-265q0 -91 -44.5 -157.5t-140.5 -124.5q95 -30 140 -105t45 -172v-265q0 -128 39 -177t148 -50v-138 q-187 1 -269.5 84t-82.5 259v207q0 71 -7.5 118t-29.5 88.5t-65.5 61t-111.5 19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    horizAdvX: 799,
    d: "M327 -400v1979h145v-1979h-145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    horizAdvX: 738,
    d: "M95 -143q108 1 147.5 50t39.5 177v265q0 95 39 153.5t145 129.5q-95 30 -139.5 104.5t-44.5 171.5v265q0 126 -39.5 176.5t-147.5 51.5v138q184 0 268 -84t84 -260v-208q0 -58 4 -96.5t16.5 -77t35.5 -61t62.5 -36.5t96.5 -15v-145q-55 0 -94 -14t-62.5 -37t-36.5 -61.5 t-17.5 -78.5t-4.5 -96v-242q0 -306 -352 -308v138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    horizAdvX: 1255,
    d: "M120 608q38 89 106.5 143.5t164.5 54.5q58 0 112 -15.5t135 -51.5q9 -4 34.5 -15t35 -15.5t30.5 -13t31.5 -12.5t27.5 -9.5t28 -8t24 -4.5t24 -2q59 0 115 44t93 112l56 -96q-39 -95 -107 -148.5t-162 -53.5q-89 0 -235 66q-65 30 -96 43t-73.5 25t-76.5 12 q-64 0 -121 -45t-94 -115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA1",
    horizAdvX: 586,
    d: "M160 1095q0 54 35 93t98 39q62 0 97.5 -39.5t35.5 -92.5t-35.5 -92.5t-97.5 -39.5q-63 0 -98 39t-35 93zM195 -139l56 919h79l62 -919v-142h-197v142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA2",
    horizAdvX: 1102,
    d: "M70 742q1 108 34 207t93 177t151 128.5t199 59.5v182h95v-182q167 -11 254 -93l-42 -119q-95 64 -212 74v-869q113 11 213 81l42 -120q-94 -86 -255 -98v-169h-95v169q-149 13 -259 95t-164 206t-54 271zM241 737q0 -171 83.5 -288t222.5 -139v864q-134 -20 -220 -142 t-86 -295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA3",
    horizAdvX: 1132,
    d: "M83 681v134h186v96q0 70 5 130t17.5 121.5t33 110.5t53.5 93t77 73.5t105 46.5t136 17q203 0 357 -130l-78 -120q-137 104 -278 104q-139 0 -197.5 -93.5t-58.5 -270.5v-178h410v-134h-410v-162q0 -137 -24.5 -223.5t-97.5 -142.5q82 5 94 5h655v-158h-972l-11 139 q99 37 141.5 112t42.5 198v232h-186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA4",
    horizAdvX: 1151,
    d: "M55 1160l74 72l184 -175q113 93 263 93q148 0 262 -94l187 176l70 -74l-184 -177q83 -117 83 -249q0 -140 -82 -250l182 -176l-69 -74l-187 176q-115 -93 -262 -93q-151 0 -263 93l-184 -175l-73 72l185 177q-83 113 -83 250q0 135 83 249zM267 732q0 -128 90.5 -218.5 t218.5 -90.5q129 0 219.5 90.5t90.5 218.5t-91 219t-219 91t-218.5 -91t-90.5 -219z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA5",
    horizAdvX: 1135,
    d: "M25 1479h178l364 -674l369 674h172l-423 -750h306v-124h-346v-182h347v-124h-347v-299h-158v299h-353v124h353v182h-352v124h304z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA6",
    horizAdvX: 788,
    d: "M322 310h146v-709h-146v709zM322 872v707h146v-707h-146z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA7",
    horizAdvX: 1017,
    d: "M141 797q0 87 45 154.5t121 107.5q-74 47 -110.5 105t-36.5 143q0 122 88 193t249 82q98 9 174.5 -4t164.5 -48q-5 -25 -13.5 -72.5t-12.5 -72.5q-135 61 -264 61q-228 0 -228 -135q0 -62 53.5 -105t198.5 -101q160 -65 234.5 -137.5t74.5 -178.5q0 -86 -43.5 -157.5 t-116.5 -117.5q149 -85 149 -236q0 -145 -115 -226t-307 -81q-186 0 -301 59v155q147 -76 303 -76q123 0 192 42.5t69 114.5q0 24 -5 42.5t-21 35.5t-30.5 28.5t-49 28.5t-60 28t-79.5 33q-172 66 -247.5 140.5t-75.5 194.5zM292 813q0 -70 53 -115t182 -96l57 -24 q143 87 143 190q0 34 -15.5 63.5t-37 49.5t-64.5 42t-77 36t-96 36q-64 -28 -104.5 -75t-40.5 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA8",
    horizAdvX: 770,
    d: "M118 1254v212h154v-212h-154zM508 1254v212h155v-212h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA9",
    horizAdvX: 1841,
    d: "M117 781q0 156 43.5 289t118 227t174.5 160t212.5 97.5t231.5 31.5q126 0 243 -32t219.5 -98t178 -160t119.5 -226.5t44 -288.5q0 -157 -43.5 -290t-118.5 -227.5t-176.5 -160.5t-218 -97.5t-242.5 -31.5q-119 0 -232 31.5t-213.5 98t-176 160t-119.5 227t-44 290.5z M230 783q0 -149 45 -278.5t128 -227t212 -154t287 -56.5q165 0 297 56t216 153.5t128.5 225.5t44.5 276t-45 276.5t-130 227t-218 155t-298 56.5q-157 0 -284.5 -56.5t-210.5 -154t-127.5 -225.5t-44.5 -274zM434 785q0 225 134 370.5t351 145.5q179 0 308 -90l-60 -97 q-45 32 -115 50t-142 18q-85 0 -151.5 -32t-107 -87t-61 -124.5t-20.5 -149.5q0 -179 91 -290.5t268 -111.5q68 0 143.5 21t118.5 51l39 -107q-55 -35 -143 -58.5t-178 -23.5q-206 0 -340.5 146t-134.5 369z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAA",
    horizAdvX: 807,
    d: "M128 1050q0 56 21.5 97t55 65.5t91 41t112.5 23.5t135 12v18q-2 90 -30 128t-100 38q-68 0 -117 -16.5t-98 -71.5l-61 78q97 127 282 127q106 0 173.5 -64t67.5 -196l-2 -348q0 -26 6 -135h-118l-3 79q-67 -100 -193 -100q-97 0 -159.5 61.5t-62.5 162.5zM134 635v106 h545v-106h-545zM247 1048q0 -111 122 -111q84 0 127 65.5t47 165.5v27q-15 -2 -47.5 -4.5t-51.5 -4.5t-48.5 -6.5t-47.5 -10.5t-39.5 -17t-33.5 -24.5t-20 -34t-8 -45.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAB",
    horizAdvX: 1000,
    d: "M100 567l293 403l143 -35l-274 -374l269 -376l-141 -36l-270 371zM469 567l304 403l128 -35l-259 -374l256 -376l-127 -36q-41 55 -116.5 159.5t-130.5 181.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAC",
    horizAdvX: 1225,
    d: "M109 681v144h991v-565h-135v421h-856z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAD",
    horizAdvX: 946,
    d: "M108 236v150h735v-150h-735z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAE",
    horizAdvX: 1824,
    d: "M117 781q0 156 43.5 289t118 227t174.5 160t212.5 97.5t231.5 31.5q126 0 243 -32t219.5 -98t178 -160t119.5 -226.5t44 -288.5q0 -157 -43.5 -290t-118.5 -227.5t-176.5 -160.5t-218 -97.5t-242.5 -31.5q-119 0 -232 31.5t-213.5 98t-176 160t-119.5 227t-44 290.5z M230 783q0 -149 45 -278.5t128 -227t212 -154t287 -56.5q165 0 297 56t216 153.5t128.5 225.5t44.5 276t-45 276.5t-130 227t-218 155t-298 56.5q-157 0 -284.5 -56.5t-210.5 -154t-127.5 -225.5t-44.5 -274zM599 301v976h258q443 0 443 -270q0 -108 -61 -181.5t-199 -90.5 q33 -26 65 -69.5t56 -86t71 -127t88 -151.5h-149l-125 224q-32 59 -48 86t-39 57.5t-45 47.5h-183v-415h-132zM731 843h126q148 0 216 32.5t68 123.5q0 94 -63.5 122t-230.5 28h-116v-306z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAF",
    horizAdvX: 1062,
    d: "M176 1503v122h710v-122h-710z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB0",
    horizAdvX: 846,
    d: "M112 1205q0 130 91.5 222t219.5 92t220 -92t92 -222q0 -128 -91 -222t-221 -94q-128 0 -219.5 93t-91.5 223zM235 1205q0 -81 55.5 -138t133.5 -57t133.5 57t55.5 138t-55.5 137.5t-133.5 56.5q-77 0 -133 -56.5t-56 -137.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB1",
    horizAdvX: 1202,
    d: "M118 0v143h970v-143h-970zM118 647v143h414v416h136v-416h418v-143h-416v-414h-137v414h-415z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB2",
    horizAdvX: 763,
    d: "M134 650v119q75 85 104 117.5t85 99t78.5 98.5t52 78t40 79t10.5 62q0 55 -33 88t-91 33q-107 0 -163 -142l-74 85q30 87 94.5 135.5t149.5 48.5q100 0 165 -68t65 -178q0 -53 -17.5 -108t-42.5 -101.5t-71.5 -105.5t-85.5 -102t-103 -110h318v-128h-481z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB3",
    horizAdvX: 756,
    d: "M132 735l55 103q77 -85 159 -85q65 0 108.5 41.5t43.5 108.5q0 76 -48.5 109.5t-141.5 33.5h-48v128h44q174 0 174 129q0 61 -34 91t-92 30q-82 0 -167 -85l-53 103q42 50 101 80.5t121 30.5q97 0 168 -68t71 -180q0 -131 -95 -193q115 -64 115 -213q0 -121 -76 -194.5 t-187 -73.5q-131 0 -218 104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB4",
    horizAdvX: 639,
    d: "M128 1250l186 388h253l-325 -388h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB6",
    horizAdvX: 1068,
    d: "M13 1212q0 69 25.5 129.5t77 110.5t140 79.5t205.5 29.5h466v-131h-75v-1588h-115v1588h-219v-1588h-125v1005q-107 2 -195.5 56t-136.5 136.5t-48 172.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB7",
    horizAdvX: 468,
    d: "M150 561v198h168v-198h-168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB8",
    horizAdvX: 596,
    d: "M114 -410l112 426h86l-44 -426h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB9",
    horizAdvX: 601,
    d: "M122 1334v102q94 48 149 103l97 -1v-792h124v-96h-357v96h118v663q-48 -32 -131 -75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBA",
    horizAdvX: 899,
    d: "M131 1210q0 164 86 272t234 108t233 -109t85 -276q0 -164 -84.5 -271.5t-231.5 -107.5q-154 0 -238 107.5t-84 276.5zM256 1207q0 -117 51 -191.5t146 -74.5q90 0 141 75.5t51 186.5q0 116 -52 193t-144 77q-89 0 -141 -76.5t-52 -189.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBB",
    horizAdvX: 1012,
    d: "M102 185l259 377l-257 373l127 35l303 -416l-304 -405zM483 185l270 377l-265 373l137 35l290 -416l-293 -405z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBC",
    horizAdvX: 1609,
    d: "M122 1334v102q94 48 149 103l97 -1v-792h124v-96h-357v96h118v663q-48 -32 -131 -75zM245 0l920 1547h135l-921 -1547h-134zM923 240v99l379 560h120v-541h94l10 -118h-106v-200h-107v200h-390zM1066 358h246q0 330 1 358z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBD",
    horizAdvX: 1591,
    d: "M122 1334v102q94 48 149 103l97 -1v-792h124v-96h-357v96h118v663q-48 -32 -131 -75zM245 0l920 1547h135l-921 -1547h-134zM934 -30v93q223 224 284 292q149 172 152 262q0 65 -40 104t-97 39t-114 -31.5t-99 -94.5l-77 65q34 79 117 124t177 45q110 0 186 -61.5 t76 -177.5q0 -36 -7 -70.5t-27 -72.5t-35.5 -65.5t-53.5 -71t-57.5 -66t-71.5 -72t-72.5 -68t-81.5 -74.5h394v-99h-553z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBE",
    horizAdvX: 1630,
    d: "M116 735l52 103q77 -85 160 -85q65 0 110.5 41.5t45.5 108.5q0 143 -191 143h-49v128h44q174 0 174 129q0 61 -34 91t-91 30q-86 0 -171 -85l-50 103q42 50 101 80.5t121 30.5q100 0 181 -68.5t81 -179.5q0 -130 -113 -193q133 -63 133 -213q0 -119 -86 -193.5 t-201 -74.5q-130 0 -217 104zM331 0l918 1547h144l-928 -1547h-134zM942 245v98l379 560h121v-542h96l8 -116h-105v-201h-107v201h-392zM1085 361h246q0 303 3 360z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBF",
    horizAdvX: 865,
    d: "M73 14q0 77 22.5 150t62.5 142.5t83.5 135t98 157.5t94.5 180h87q0 -64 -29.5 -147t-71.5 -162.5t-83.5 -157.5t-71 -154t-29.5 -130q1 -95 61 -141t164 -46q129 0 259 81l45 -135q-123 -97 -331 -97q-162 0 -261.5 85.5t-99.5 238.5zM330 1094q0 54 35 93t98 39 q62 0 97.5 -39.5t35.5 -92.5t-35.5 -92.5t-97.5 -39.5q-63 0 -98 39t-35 93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC0",
    horizAdvX: 1302,
    d: "M3 0l568 1482h177l551 -1482h-178l-173 469h-590l-179 -469h-176zM272 2014h250l185 -387h-112zM416 614h476q-211 613 -233 689z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC1",
    horizAdvX: 1302,
    d: "M3 0l568 1482h177l551 -1482h-178l-173 469h-590l-179 -469h-176zM416 614h476q-211 613 -233 689zM594 1627l186 388h253l-325 -388h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC2",
    horizAdvX: 1302,
    d: "M3 0l568 1482h177l551 -1482h-178l-173 469h-590l-179 -469h-176zM358 1627l187 388h213l187 -388h-134l-161 272l-161 -272h-131zM416 614h476q-211 613 -233 689z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC3",
    horizAdvX: 1302,
    d: "M3 0l568 1482h177l551 -1482h-178l-173 469h-590l-179 -469h-176zM287 1690q35 98 82 139t107 41q45 0 106.5 -24t120.5 -48t100 -24q83 0 125 98l86 -36q-35 -116 -85.5 -162.5t-115.5 -46.5q-46 0 -108 23t-121.5 46.5t-98.5 23.5q-77 0 -116 -85zM416 614h476 q-211 613 -233 689z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC4",
    horizAdvX: 1302,
    d: "M3 0l568 1482h177l551 -1482h-178l-173 469h-590l-179 -469h-176zM378 1627v212h154v-212h-154zM416 614h476q-211 613 -233 689zM768 1627v212h155v-212h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC5",
    horizAdvX: 1302,
    d: "M3 0l568 1482h177l551 -1482h-178l-173 469h-590l-179 -469h-176zM401 1741q0 103 73.5 177t175.5 74q103 0 176.5 -74t73.5 -177q0 -102 -73 -177.5t-177 -75.5q-102 0 -175.5 74.5t-73.5 178.5zM416 614h476q-211 613 -233 689zM500 1741q0 -65 44.5 -110.5 t106.5 -45.5t106.5 46t44.5 110q0 65 -44.5 110t-106.5 45t-106.5 -45t-44.5 -110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC6",
    horizAdvX: 2092,
    d: "M85 0l916 1568h945v-159h-705l39 -527h631v-158h-611l42 -566h624v-158h-783l-31 427h-654l-240 -427h-173zM582 589h548l-61 820z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC7",
    horizAdvX: 1290,
    d: "M112 745q0 166 49 306t138.5 240.5t223.5 156.5t298 56q249 0 420 -110l-68 -141q-164 99 -350 99q-167 0 -287.5 -81t-179.5 -218t-59 -315q0 -133 32 -242.5t96 -192t166.5 -128t235.5 -45.5q171 0 354 89l29 -147q-149 -94 -403 -94q-167 0 -299.5 55.5t-219 157 t-131.5 242t-45 312.5zM522 -434l112 426h86l-44 -426h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC8",
    horizAdvX: 1143,
    d: "M174 0v1479h848l-7 -153h-668v-484h635v-151h-635v-538h690l-8 -153h-855zM227 2014h250l185 -387h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC9",
    horizAdvX: 1143,
    d: "M174 0v1479h848l-7 -153h-668v-484h635v-151h-635v-538h690l-8 -153h-855zM548 1627l186 388h253l-325 -388h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCA",
    horizAdvX: 1143,
    d: "M174 0v1479h848l-7 -153h-668v-484h635v-151h-635v-538h690l-8 -153h-855zM312 1627l187 388h213l187 -388h-134l-161 272l-161 -272h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCB",
    horizAdvX: 1143,
    d: "M174 0v1479h848l-7 -153h-668v-484h635v-151h-635v-538h690l-8 -153h-855zM333 1627v212h154v-212h-154zM723 1627v212h155v-212h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCC",
    horizAdvX: 540,
    d: "M-111 2014h250l185 -387h-112zM182 0v1479h173v-1479h-173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCD",
    horizAdvX: 540,
    d: "M182 0v1479h173v-1479h-173zM212 1627l186 388h253l-325 -388h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCE",
    horizAdvX: 540,
    d: "M-25 1627l187 388h213l187 -388h-134l-161 272l-161 -272h-131zM182 0v1479h173v-1479h-173z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCF",
    horizAdvX: 540,
    d: "M-4 1627v212h154v-212h-154zM182 0v1479h173v-1479h-173zM386 1627v212h155v-212h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD0",
    horizAdvX: 1522,
    d: "M29 697v135h118v664h372q161 0 292 -23t245 -78t191 -140.5t121 -216.5t44 -300q0 -183 -57 -324.5t-162 -231.5t-249 -136t-323 -46h-474v697h-118zM324 155h315q279 0 431.5 146.5t152.5 432.5q0 139 -32.5 244t-89.5 173.5t-144 111.5t-188 60.5t-229 17.5h-216v-509 h242v-135h-242v-542z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD1",
    horizAdvX: 1516,
    d: "M174 0v1479h193l770 -1164l51 -69q-7 319 -7 369v864h161v-1479h-196l-768 1164l-50 69q8 -210 8 -375v-858h-162zM395 1690q35 98 82 139t107 41q45 0 106.5 -24t120.5 -48t100 -24q83 0 125 98l86 -36q-35 -116 -85.5 -162.5t-115.5 -46.5q-46 0 -108 23t-121.5 46.5 t-98.5 23.5q-77 0 -116 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD2",
    d: "M112 740q0 355 185 560t518 205q328 0 513.5 -206.5t185.5 -559.5q0 -169 -46.5 -309t-134 -240.5t-220.5 -156t-299 -55.5q-224 0 -383.5 95.5t-239 266t-79.5 400.5zM296 739q0 -285 131 -447.5t387 -162.5t385.5 162t129.5 448q0 292 -130.5 453t-383.5 161t-386 -161 t-133 -453zM434 2014h250l185 -387h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD3",
    d: "M112 740q0 355 185 560t518 205q328 0 513.5 -206.5t185.5 -559.5q0 -169 -46.5 -309t-134 -240.5t-220.5 -156t-299 -55.5q-224 0 -383.5 95.5t-239 266t-79.5 400.5zM296 739q0 -285 131 -447.5t387 -162.5t385.5 162t129.5 448q0 292 -130.5 453t-383.5 161t-386 -161 t-133 -453zM756 1627l186 388h253l-325 -388h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD4",
    d: "M112 740q0 355 185 560t518 205q328 0 513.5 -206.5t185.5 -559.5q0 -169 -46.5 -309t-134 -240.5t-220.5 -156t-299 -55.5q-224 0 -383.5 95.5t-239 266t-79.5 400.5zM296 739q0 -285 131 -447.5t387 -162.5t385.5 162t129.5 448q0 292 -130.5 453t-383.5 161t-386 -161 t-133 -453zM520 1627l187 388h213l187 -388h-134l-161 272l-161 -272h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD5",
    d: "M112 740q0 355 185 560t518 205q328 0 513.5 -206.5t185.5 -559.5q0 -169 -46.5 -309t-134 -240.5t-220.5 -156t-299 -55.5q-224 0 -383.5 95.5t-239 266t-79.5 400.5zM296 739q0 -285 131 -447.5t387 -162.5t385.5 162t129.5 448q0 292 -130.5 453t-383.5 161t-386 -161 t-133 -453zM449 1690q35 98 82 139t107 41q45 0 106.5 -24t120.5 -48t100 -24q83 0 125 98l86 -36q-35 -116 -85.5 -162.5t-115.5 -46.5q-46 0 -108 23t-121.5 46.5t-98.5 23.5q-77 0 -116 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD6",
    d: "M112 740q0 355 185 560t518 205q328 0 513.5 -206.5t185.5 -559.5q0 -169 -46.5 -309t-134 -240.5t-220.5 -156t-299 -55.5q-224 0 -383.5 95.5t-239 266t-79.5 400.5zM296 739q0 -285 131 -447.5t387 -162.5t385.5 162t129.5 448q0 292 -130.5 453t-383.5 161t-386 -161 t-133 -453zM540 1627v212h154v-212h-154zM930 1627v212h155v-212h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD7",
    horizAdvX: 993,
    d: "M116 278l285 326l-285 328l106 95l274 -314l274 314l106 -95l-285 -328l285 -326l-108 -97l-272 313l-272 -313z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD8",
    d: "M112 740q0 355 185 560t518 205q125 0 232 -32l89 220l131 -46l-92 -227q164 -90 251.5 -265.5t87.5 -415.5q0 -169 -46.5 -309t-134 -240.5t-220.5 -156t-299 -55.5q-115 0 -216 26l-96 -236l-125 43l96 239q-176 86 -268.5 264.5t-92.5 425.5zM296 739 q0 -191 60 -329.5t178 -210.5l455 1130q-78 24 -174 24q-253 0 -386 -161t-133 -453zM657 148q76 -19 157 -19q256 0 385.5 162t129.5 448q0 382 -215 531z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD9",
    horizAdvX: 1438,
    d: "M156 521v958h174v-961q0 -201 95 -296t294 -95q194 0 289.5 96t95.5 296v960h173v-960q0 -255 -139.5 -398t-424.5 -143t-421 143t-136 400zM337 2014h250l185 -387h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDA",
    horizAdvX: 1438,
    d: "M156 521v958h174v-961q0 -201 95 -296t294 -95q194 0 289.5 96t95.5 296v960h173v-960q0 -255 -139.5 -398t-424.5 -143t-421 143t-136 400zM660 1627l186 388h253l-325 -388h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDB",
    horizAdvX: 1438,
    d: "M156 521v958h174v-961q0 -201 95 -296t294 -95q194 0 289.5 96t95.5 296v960h173v-960q0 -255 -139.5 -398t-424.5 -143t-421 143t-136 400zM423 1627l187 388h213l187 -388h-134l-161 272l-161 -272h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDC",
    horizAdvX: 1438,
    d: "M156 521v958h174v-961q0 -201 95 -296t294 -95q194 0 289.5 96t95.5 296v960h173v-960q0 -255 -139.5 -398t-424.5 -143t-421 143t-136 400zM444 1627v212h154v-212h-154zM834 1627v212h155v-212h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDD",
    horizAdvX: 1194,
    d: "M-1 1479h187l405 -725l416 725h188l-522 -889v-590h-175v586zM540 1627l186 388h253l-325 -388h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDE",
    horizAdvX: 1291,
    d: "M147 0v1496h177v-279h324q281 0 421 -98.5t140 -327.5q0 -210 -120 -329.5t-370 -119.5l-395 7v-349h-177zM324 493h384q332 0 332 289q0 150 -85.5 218t-288.5 68h-342v-575z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDF",
    horizAdvX: 1222,
    d: "M118 0v1046q0 229 112 354t338 125q190 0 305 -91.5t115 -251.5q0 -40 -8 -73.5t-27 -62t-36.5 -49t-50.5 -44.5t-55 -38t-64 -39t-64 -38q38 -27 100 -64.5t109.5 -65.5t101.5 -68.5t89.5 -80t59 -94.5t23.5 -117q0 -93 -28.5 -161.5t-81 -108.5t-119.5 -59t-151 -19 h-343l16 148h312q97 0 151.5 52.5t54.5 142.5q0 50 -26 95.5t-74 83.5t-92 66.5t-105 63t-89 53.5q-82 56 -82 117q0 58 65 112q26 21 75 52.5t76.5 51.5t50.5 58t23 86q0 87 -67 139t-164 52q-282 0 -282 -317v-1056h-168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE0",
    horizAdvX: 1098,
    d: "M94 289q0 168 127.5 249t367.5 101q33 3 99.5 8.5t99.5 8.5v97q0 116 -54 172t-170 56q-162 0 -327 -80q-5 12 -26 69.5t-22 59.5q73 41 173.5 65.5t204.5 24.5q205 0 295.5 -89.5t90.5 -304.5v-726h-130q-15 64 -29 138q-91 -91 -171 -126t-188 -35q-154 0 -247.5 80.5 t-93.5 231.5zM145 1629h250l185 -387h-112zM265 290q0 -88 52 -133t143 -45q119 0 209.5 65.5t116.5 176.5v185q-5 0 -60.5 -5t-72.5 -6q-217 -19 -302.5 -71t-85.5 -167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE1",
    horizAdvX: 1098,
    d: "M94 289q0 168 127.5 249t367.5 101q33 3 99.5 8.5t99.5 8.5v97q0 116 -54 172t-170 56q-162 0 -327 -80q-5 12 -26 69.5t-22 59.5q73 41 173.5 65.5t204.5 24.5q205 0 295.5 -89.5t90.5 -304.5v-726h-130q-15 64 -29 138q-91 -91 -171 -126t-188 -35q-154 0 -247.5 80.5 t-93.5 231.5zM265 290q0 -88 52 -133t143 -45q119 0 209.5 65.5t116.5 176.5v185q-5 0 -60.5 -5t-72.5 -6q-217 -19 -302.5 -71t-85.5 -167zM466 1242l186 388h253l-325 -388h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE2",
    horizAdvX: 1098,
    d: "M94 289q0 168 127.5 249t367.5 101q33 3 99.5 8.5t99.5 8.5v97q0 116 -54 172t-170 56q-162 0 -327 -80q-5 12 -26 69.5t-22 59.5q73 41 173.5 65.5t204.5 24.5q205 0 295.5 -89.5t90.5 -304.5v-726h-130q-15 64 -29 138q-91 -91 -171 -126t-188 -35q-154 0 -247.5 80.5 t-93.5 231.5zM230 1242l187 388h213l187 -388h-134l-161 272l-161 -272h-131zM265 290q0 -88 52 -133t143 -45q119 0 209.5 65.5t116.5 176.5v185q-5 0 -60.5 -5t-72.5 -6q-217 -19 -302.5 -71t-85.5 -167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE3",
    horizAdvX: 1098,
    d: "M94 289q0 168 127.5 249t367.5 101q33 3 99.5 8.5t99.5 8.5v97q0 116 -54 172t-170 56q-162 0 -327 -80q-5 12 -26 69.5t-22 59.5q73 41 173.5 65.5t204.5 24.5q205 0 295.5 -89.5t90.5 -304.5v-726h-130q-15 64 -29 138q-91 -91 -171 -126t-188 -35q-154 0 -247.5 80.5 t-93.5 231.5zM160 1305q35 98 82 139t107 41q45 0 106.5 -24t120.5 -48t100 -24q83 0 125 98l86 -36q-35 -116 -85.5 -162.5t-115.5 -46.5q-46 0 -108 23t-121.5 46.5t-98.5 23.5q-77 0 -116 -85zM265 290q0 -88 52 -133t143 -45q119 0 209.5 65.5t116.5 176.5v185 q-5 0 -60.5 -5t-72.5 -6q-217 -19 -302.5 -71t-85.5 -167z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE4",
    horizAdvX: 1098,
    d: "M94 289q0 168 127.5 249t367.5 101q33 3 99.5 8.5t99.5 8.5v97q0 116 -54 172t-170 56q-162 0 -327 -80q-5 12 -26 69.5t-22 59.5q73 41 173.5 65.5t204.5 24.5q205 0 295.5 -89.5t90.5 -304.5v-726h-130q-15 64 -29 138q-91 -91 -171 -126t-188 -35q-154 0 -247.5 80.5 t-93.5 231.5zM251 1242v212h154v-212h-154zM265 290q0 -88 52 -133t143 -45q119 0 209.5 65.5t116.5 176.5v185q-5 0 -60.5 -5t-72.5 -6q-217 -19 -302.5 -71t-85.5 -167zM641 1242v212h155v-212h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE5",
    horizAdvX: 1098,
    d: "M94 289q0 168 127.5 249t367.5 101q33 3 99.5 8.5t99.5 8.5v97q0 116 -54 172t-170 56q-162 0 -327 -80q-5 12 -26 69.5t-22 59.5q73 41 173.5 65.5t204.5 24.5q205 0 295.5 -89.5t90.5 -304.5v-726h-130q-15 64 -29 138q-91 -91 -171 -126t-188 -35q-154 0 -247.5 80.5 t-93.5 231.5zM265 290q0 -88 52 -133t143 -45q119 0 209.5 65.5t116.5 176.5v185q-5 0 -60.5 -5t-72.5 -6q-217 -19 -302.5 -71t-85.5 -167zM274 1495q0 103 73.5 177t175.5 74q103 0 176.5 -74t73.5 -177q0 -102 -73 -177.5t-177 -75.5q-102 0 -175.5 74.5t-73.5 178.5z M373 1495q0 -65 44.5 -110.5t106.5 -45.5t106.5 46t44.5 110q0 65 -44.5 110t-106.5 45t-106.5 -45t-44.5 -110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE6",
    horizAdvX: 1674,
    d: "M80 300q0 55 16.5 99.5t43 75t71 54t88 37.5t108 24t117 14.5t127.5 8.5l63 3v165q0 102 -43 148.5t-147 46.5q-98 0 -194 -23.5t-162 -58.5l-36 138q65 37 173.5 64.5t214.5 27.5q124 0 209.5 -49t107.5 -143q53 95 147.5 143.5t207.5 48.5q99 0 173 -36.5t117 -99.5 t63.5 -139.5t20.5 -164.5q0 -78 -36.5 -111t-150.5 -39l-497 -25q13 -187 86.5 -288.5t225.5 -101.5q88 0 174 33t149 77l52 -121q-154 -133 -386 -133q-202 0 -327 137q-95 -59 -218 -98.5t-234 -39.5q-143 0 -233.5 78.5t-90.5 247.5zM248 291q0 -178 168 -178 q32 0 67.5 5.5t81.5 18t71.5 20.5t82 27.5t68.5 23.5q-67 122 -76 291q-44 -2 -64 -4q-158 -12 -246 -38t-120.5 -64.5t-32.5 -101.5zM888 615l516 29v10q-2 171 -53.5 250.5t-161.5 79.5q-143 0 -217.5 -101.5t-83.5 -267.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE7",
    horizAdvX: 968,
    d: "M92 545q1 256 139.5 415.5t379.5 159.5q85 0 164.5 -21t125.5 -55l-46 -130q-117 63 -247 63q-159 0 -251.5 -116t-92.5 -317q0 -196 91.5 -310.5t253.5 -114.5q129 0 264 70l21 -133q-109 -79 -287 -79q-242 0 -378.5 157t-136.5 411zM342 -435l112 426h86l-44 -426 h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE8",
    horizAdvX: 1108,
    d: "M93 545q0 255 133 413.5t350 161.5q204 0 323.5 -139.5t119.5 -372.5q0 -12 -0.5 -44t-0.5 -46h-753q3 -187 96.5 -291.5t251.5 -104.5q174 0 349 92l26 -135q-167 -102 -381 -102q-239 0 -376.5 152t-137.5 416zM177 1629h250l185 -387h-112zM270 644h579 q0 163 -73.5 250.5t-201.5 87.5t-209 -90.5t-95 -247.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE9",
    horizAdvX: 1108,
    d: "M93 545q0 255 133 413.5t350 161.5q204 0 323.5 -139.5t119.5 -372.5q0 -12 -0.5 -44t-0.5 -46h-753q3 -187 96.5 -291.5t251.5 -104.5q174 0 349 92l26 -135q-167 -102 -381 -102q-239 0 -376.5 152t-137.5 416zM270 644h579q0 163 -73.5 250.5t-201.5 87.5t-209 -90.5 t-95 -247.5zM499 1242l186 388h253l-325 -388h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEA",
    horizAdvX: 1108,
    d: "M93 545q0 255 133 413.5t350 161.5q204 0 323.5 -139.5t119.5 -372.5q0 -12 -0.5 -44t-0.5 -46h-753q3 -187 96.5 -291.5t251.5 -104.5q174 0 349 92l26 -135q-167 -102 -381 -102q-239 0 -376.5 152t-137.5 416zM262 1242l187 388h213l187 -388h-134l-161 272l-161 -272 h-131zM270 644h579q0 163 -73.5 250.5t-201.5 87.5t-209 -90.5t-95 -247.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEB",
    horizAdvX: 1108,
    d: "M93 545q0 255 133 413.5t350 161.5q204 0 323.5 -139.5t119.5 -372.5q0 -12 -0.5 -44t-0.5 -46h-753q3 -187 96.5 -291.5t251.5 -104.5q174 0 349 92l26 -135q-167 -102 -381 -102q-239 0 -376.5 152t-137.5 416zM270 644h579q0 163 -73.5 250.5t-201.5 87.5t-209 -90.5 t-95 -247.5zM284 1242v212h154v-212h-154zM674 1242v212h155v-212h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEC",
    horizAdvX: 430,
    d: "M-159 1629h250l185 -387h-112zM135 0v1098h169v-1098h-169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xED",
    horizAdvX: 430,
    d: "M135 0v1098h169v-1098h-169zM162 1242l186 388h253l-325 -388h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEE",
    horizAdvX: 430,
    d: "M-74 1242l187 388h213l187 -388h-134l-161 272l-161 -272h-131zM135 0v1098h169v-1098h-169z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEF",
    horizAdvX: 430,
    d: "M-53 1242v212h154v-212h-154zM135 0v1098h169v-1098h-169zM337 1242v212h155v-212h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF0",
    horizAdvX: 1204,
    d: "M87 486q0 219 132.5 352.5t349.5 133.5q146 0 275 -95q-83 158 -303 380l-272 -112l-43 132l220 87l-236 224h223l146 -159l289 113l46 -129l-242 -93q248 -270 343 -436q102 -192 102 -392q0 -111 -33 -204.5t-96 -163.5t-161.5 -109.5t-223.5 -39.5q-121 0 -220 41 t-163 111.5t-98.5 162.5t-34.5 196zM269 485q0 -99 36.5 -181t115.5 -136t188 -54q157 0 246.5 101t89.5 257q0 69 -22.5 133t-64.5 115t-108.5 82t-146.5 31q-154 0 -244 -100t-90 -248z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF1",
    horizAdvX: 1184,
    d: "M143 0v1097h140l21 -157q65 81 162.5 130.5t210.5 49.5q190 0 281 -106.5t91 -327.5v-686h-167q0 660 -1 707q-4 140 -56.5 205t-175.5 65q-129 0 -215 -62t-112 -161q-10 -67 -10 -154v-600h-169zM233 1305q35 98 82 139t107 41q45 0 106.5 -24t120.5 -48t100 -24 q83 0 125 98l86 -36q-35 -116 -85.5 -162.5t-115.5 -46.5q-46 0 -108 23t-121.5 46.5t-98.5 23.5q-77 0 -116 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF2",
    horizAdvX: 1201,
    d: "M92 548q0 256 137 414t376 158q235 0 369 -158.5t134 -412.5q0 -255 -136 -413.5t-376 -158.5q-231 0 -367.5 160t-136.5 411zM221 1629h250l185 -387h-112zM265 546q0 -195 86.5 -312.5t252.5 -117.5q164 0 247.5 117t83.5 315q0 201 -82.5 316.5t-251.5 115.5 q-164 0 -250 -118t-86 -316z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF3",
    horizAdvX: 1201,
    d: "M92 548q0 256 137 414t376 158q235 0 369 -158.5t134 -412.5q0 -255 -136 -413.5t-376 -158.5q-231 0 -367.5 160t-136.5 411zM265 546q0 -195 86.5 -312.5t252.5 -117.5q164 0 247.5 117t83.5 315q0 201 -82.5 316.5t-251.5 115.5q-164 0 -250 -118t-86 -316zM543 1242 l186 388h253l-325 -388h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF4",
    horizAdvX: 1201,
    d: "M92 548q0 256 137 414t376 158q235 0 369 -158.5t134 -412.5q0 -255 -136 -413.5t-376 -158.5q-231 0 -367.5 160t-136.5 411zM265 546q0 -195 86.5 -312.5t252.5 -117.5q164 0 247.5 117t83.5 315q0 201 -82.5 316.5t-251.5 115.5q-164 0 -250 -118t-86 -316zM306 1242 l187 388h213l187 -388h-134l-161 272l-161 -272h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF5",
    horizAdvX: 1201,
    d: "M92 548q0 256 137 414t376 158q235 0 369 -158.5t134 -412.5q0 -255 -136 -413.5t-376 -158.5q-231 0 -367.5 160t-136.5 411zM237 1305q35 98 82 139t107 41q45 0 106.5 -24t120.5 -48t100 -24q83 0 125 98l86 -36q-35 -116 -85.5 -162.5t-115.5 -46.5q-46 0 -108 23 t-121.5 46.5t-98.5 23.5q-77 0 -116 -85zM265 546q0 -195 86.5 -312.5t252.5 -117.5q164 0 247.5 117t83.5 315q0 201 -82.5 316.5t-251.5 115.5q-164 0 -250 -118t-86 -316z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF6",
    horizAdvX: 1201,
    d: "M92 548q0 256 137 414t376 158q235 0 369 -158.5t134 -412.5q0 -255 -136 -413.5t-376 -158.5q-231 0 -367.5 160t-136.5 411zM265 546q0 -195 86.5 -312.5t252.5 -117.5q164 0 247.5 117t83.5 315q0 201 -82.5 316.5t-251.5 115.5q-164 0 -250 -118t-86 -316zM328 1242 v212h154v-212h-154zM718 1242v212h155v-212h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF7",
    horizAdvX: 1211,
    d: "M97 523v149h1001v-149h-1001zM491 22v227h191v-227h-191zM491 939v227h225v-227h-225z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF8",
    horizAdvX: 1200,
    d: "M92 548q0 256 137 414t376 158q102 0 190 -33l107 240l77 -31l-110 -245q115 -70 177 -201.5t62 -300.5q0 -255 -136 -413.5t-376 -158.5q-105 0 -192 35l-110 -247l-71 38l109 245q-115 71 -177.5 202t-62.5 298zM265 546q0 -247 129 -358l342 767q-61 25 -135 25 q-164 0 -250 -118t-86 -316zM463 144q62 -28 141 -28q164 0 247.5 117t83.5 315q0 257 -128 365z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF9",
    horizAdvX: 1100,
    d: "M105 366v731h168v-733q0 -72 20.5 -122t59 -77.5t87 -39.5t111.5 -12q130 0 202.5 57t72.5 194v733h168v-731q0 -84 -24 -151t-64.5 -111.5t-97.5 -73.5t-120.5 -42t-136.5 -13q-72 0 -136 13t-121.5 42.5t-99 74t-65.5 111.5t-24 150zM171 1629h250l185 -387h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFA",
    horizAdvX: 1100,
    d: "M105 366v731h168v-733q0 -72 20.5 -122t59 -77.5t87 -39.5t111.5 -12q130 0 202.5 57t72.5 194v733h168v-731q0 -84 -24 -151t-64.5 -111.5t-97.5 -73.5t-120.5 -42t-136.5 -13q-72 0 -136 13t-121.5 42.5t-99 74t-65.5 111.5t-24 150zM492 1242l186 388h253l-325 -388 h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFB",
    horizAdvX: 1100,
    d: "M105 366v731h168v-733q0 -72 20.5 -122t59 -77.5t87 -39.5t111.5 -12q130 0 202.5 57t72.5 194v733h168v-731q0 -84 -24 -151t-64.5 -111.5t-97.5 -73.5t-120.5 -42t-136.5 -13q-72 0 -136 13t-121.5 42.5t-99 74t-65.5 111.5t-24 150zM256 1242l187 388h213l187 -388 h-134l-161 272l-161 -272h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFC",
    horizAdvX: 1100,
    d: "M105 366v731h168v-733q0 -72 20.5 -122t59 -77.5t87 -39.5t111.5 -12q130 0 202.5 57t72.5 194v733h168v-731q0 -84 -24 -151t-64.5 -111.5t-97.5 -73.5t-120.5 -42t-136.5 -13q-72 0 -136 13t-121.5 42.5t-99 74t-65.5 111.5t-24 150zM277 1242v212h154v-212h-154z M667 1242v212h155v-212h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFD",
    horizAdvX: 1022,
    d: "M3 1097h177l346 -913l308 913h177q-444 -1222 -459 -1260q-69 -173 -167 -253.5t-258 -80.5q-48 0 -101 8l-10 142q56 -4 84 -4q113 0 171.5 41.5t104.5 155.5q41 105 61 162zM450 1242l186 388h253l-325 -388h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFE",
    horizAdvX: 1205,
    d: "M124 -459v1672v297h168v-577q129 191 351 191q135 -1 239.5 -75.5t160.5 -202t56 -286.5q0 -89 -17.5 -173t-54.5 -159t-90 -131t-128.5 -89t-165.5 -33q-241 0 -351 187v-621h-168zM290 551q0 -90 19 -166.5t58 -138.5t104.5 -97.5t152.5 -35.5q67 0 121 27.5t87 71.5 t55 103t30.5 117t8.5 119q0 78 -14.5 150t-46.5 138.5t-92 106.5t-142 40q-109 0 -188 -61.5t-116 -158.5t-37 -215z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFF",
    horizAdvX: 1022,
    d: "M3 1097h177l346 -913l308 913h177q-444 -1222 -459 -1260q-69 -173 -167 -253.5t-258 -80.5q-48 0 -101 8l-10 142q56 -4 84 -4q113 0 171.5 41.5t104.5 155.5q41 105 61 162zM234 1242v212h154v-212h-154zM624 1242v212h155v-212h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0152",
    horizAdvX: 1980,
    d: "M101 771q5 216 95 387.5t248 268.5t356 97q108 0 199 -30t149 -81v82h726l-17 -154h-532v-496h496v-153h-496v-536h573l-15 -156h-735v82q-34 -36 -137 -70.5t-188 -34.5q-233 0 -397 101t-244.5 278t-80.5 415zM291 773q0 -110 17.5 -203.5t57.5 -175t101 -139.5 t152 -91.5t205 -34.5q86 0 180 31.5t144 61.5v1037q-139 114 -333 114q-238 0 -378 -166.5t-146 -433.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0153",
    horizAdvX: 1916,
    d: "M82 547q0 119 33.5 223t95.5 183t160 125t219 46q146 0 250.5 -62t164.5 -173q61 106 170 168.5t239 66.5q202 0 311 -141.5t109 -388.5q0 -8 -1 -36.5t-1 -38.5h-739q0 -182 95 -291t242 -109q105 0 183.5 30t152.5 80l52 -122q-154 -132 -393 -132q-144 0 -253 61 t-172 175q-63 -110 -167.5 -173t-245.5 -63q-161 0 -277 78t-172 205.5t-56 288.5zM255 544q0 -86 19 -161t58 -137t105 -97.5t153 -35.5q86 0 151.5 36t103.5 97.5t57 137.5t19 163q0 91 -18 167.5t-56 139t-104.5 97.5t-155.5 35q-69 0 -125 -24.5t-94 -66.5t-64 -99 t-37.5 -120t-11.5 -132zM1099 634h573v13q-3 166 -74.5 253.5t-193.5 87.5q-125 0 -208 -96t-97 -258z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0178",
    horizAdvX: 1194,
    d: "M-1 1479h187l405 -725l416 725h188l-522 -889v-590h-175v586zM324 1627v212h154v-212h-154zM714 1627v212h155v-212h-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02C6",
    horizAdvX: 800,
    d: "M108 1251l187 388h213l187 -388h-134l-161 272l-161 -272h-131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02DC",
    horizAdvX: 1257,
    d: "M265 177q35 98 82 139t107 41q45 0 106.5 -24t120.5 -48t100 -24q83 0 125 98l86 -36q-35 -116 -85.5 -162.5t-115.5 -46.5q-46 0 -108 23t-121.5 46.5t-98.5 23.5q-77 0 -116 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2000",
    horizAdvX: 1007
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2001",
    horizAdvX: 2015
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2002",
    horizAdvX: 1007
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2003",
    horizAdvX: 2015
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2004",
    horizAdvX: 671
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2005",
    horizAdvX: 503
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2006",
    horizAdvX: 335
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2007",
    horizAdvX: 335
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2008",
    horizAdvX: 251
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2009",
    horizAdvX: 403
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u200A",
    horizAdvX: 111
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2010",
    horizAdvX: 672,
    d: "M86 497v147h500v-147h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2011",
    horizAdvX: 672,
    d: "M86 497v147h500v-147h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2012",
    horizAdvX: 672,
    d: "M86 497v147h500v-147h-500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2013",
    horizAdvX: 1317,
    d: "M139 527v148h1047v-148h-1047z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2014",
    horizAdvX: 2427,
    d: "M139 527v148h2157v-148h-2157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2018",
    horizAdvX: 510,
    d: "M129 1102l136 472h117l-91 -472h-162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2019",
    horizAdvX: 504,
    d: "M133 1102l93 472h157l-134 -472h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201A",
    horizAdvX: 504,
    d: "M126 -256l92 472h161l-134 -472h-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201C",
    horizAdvX: 818,
    d: "M129 1102l134 472h120l-94 -472h-160zM438 1102l135 472h117l-90 -472h-162z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201D",
    horizAdvX: 795,
    d: "M133 1102l93 472h159l-135 -472h-117zM420 1102l91 472h163l-137 -472h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201E",
    horizAdvX: 819,
    d: "M126 -256l90 472h161l-133 -472h-118zM441 -256l91 472h162l-135 -472h-118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2022",
    horizAdvX: 867,
    d: "M137 747q0 137 90 238t209 101q121 0 208 -98.5t87 -234.5q0 -138 -89 -238t-210 -100q-123 0 -209 98t-86 234z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2026",
    horizAdvX: 1482,
    d: "M128 120q0 54 35 93t98 39t98 -39t35 -93t-35 -93t-98 -39q-62 0 -97.5 39.5t-35.5 92.5zM622 120q0 54 35 93t98 39t98 -39t35 -93t-35 -93t-98 -39q-62 0 -97.5 39.5t-35.5 92.5zM1116 120q0 54 35 93t98 39t98 -39t35 -93t-35 -93t-98 -39q-62 0 -97.5 39.5 t-35.5 92.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u202F",
    horizAdvX: 403
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2039",
    horizAdvX: 620,
    d: "M120 583l241 399h140l-232 -399l226 -401h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u203A",
    horizAdvX: 617,
    d: "M124 182l231 403l-225 397h139l236 -397l-241 -403h-140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u205F",
    horizAdvX: 503
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u20AC",
    horizAdvX: 1210,
    d: "M105 845l19 112h110q19 126 63.5 228.5t113 179t167 118t218.5 41.5q181 0 292 -95l-1 -180q-110 120 -269 120q-165 0 -263 -109.5t-130 -302.5h558l-17 -112h-559q-2 -21 -3 -62t-1 -70.5t-1 -29.5h549l-10 -103h-522q11 -91 39 -169t73 -141t114 -99t155 -36 q148 0 288 109l-1 -175q-125 -91 -306 -91q-101 0 -187 35t-146.5 92.5t-107 136.5t-73.5 162.5t-40 175.5h-121l17 103h92q-2 32 -2 48q0 21 5 114h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2122",
    horizAdvX: 1812,
    d: "M90 1394v102h637v-102h-264v-785h-114v785h-259zM849 609v887h157l268 -672l281 672h149v-887h-114v740l-280 -669h-86l-264 669v-740h-111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u25FC",
    horizAdvX: 1095,
    d: "M0 0v1095h1095v-1095h-1095z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u201D",
    k: 200
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u2019",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "b",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "c",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "d",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "o",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "f",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "g",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "o",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "T",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "V",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "W",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "Y,Yacute,Ydieresis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "quotedblright",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "quoteright",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "v",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "w",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "y,yacute,ydieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "comma",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "period",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "W",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "X",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "Y,Yacute,Ydieresis",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "comma",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "period",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "v",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "w",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "y,yacute,ydieresis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "T",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "V",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "W",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "Y,Yacute,Ydieresis",
    k: 147
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "y,yacute,ydieresis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "comma",
    k: 280
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "period",
    k: 230
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "comma",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "hyphen",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "period",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "s",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "w",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "y,yacute,ydieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma",
    k: 190
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "period",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "comma",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "hyphen",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "period",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,OE",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 134
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "comma",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "g",
    k: 190
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "hyphen",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "m,n,ntilde",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "period",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "s",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn",
    g2: "comma",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn",
    g2: "period",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn",
    g2: "w",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn",
    g2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn",
    g2: "y,yacute,ydieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "g",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "comma",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "g",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "period",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t",
    g2: "g",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "comma",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "period",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "comma",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "period",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,oe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "comma",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "g",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "period",
    k: 100
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxygenRegular);
export default __webpack_public_path__ + "static/media/oxygen-regular.af82242cd6e144966d46af15d7fbe141.svg";
export { ForwardRef as ReactComponent };